const timeoutMinutes = 20;

export const sessionTimeLimit = 1000 * 60 * timeoutMinutes;
export const pollingLimit = 5000;
